import { ROUTES } from '@common/modules/router/constants/common'

/**
 * The routes on which the mobile-web SPA signs a stand-alone `calls` request
 * IN PLACE — `SignAccountOpOverlay` renders the sign screen on top of the
 * current screen instead of navigating to `/sign-account-op`.
 *
 * These are the screens that raise a `calls` request themselves and then keep a
 * hook alive waiting for its result: the CCTP burn, and the PulseChain permit
 * swap's wrap / approve / unwrap steps (`usePermitSwap`). Navigating away
 * unmounts that hook — the flow's polling stops, and the user has to walk back
 * into the screen by hand for it to continue.
 *
 * Activity is in the list for the DCA cancel (Activity → DCA → order → Cancel),
 * which raises its `cancelOrder` / approval requests from there.
 *
 * Shared with `usePermitSwap` so the hook's "surface the request" fallback and
 * the overlay's gate can never disagree: a route in this list must NOT be
 * navigated away from, and one outside it has no overlay and therefore must be.
 */
export const SIGN_ACCOUNT_OP_OVERLAY_ROUTES: string[] = [
  ROUTES.swap,
  ROUTES.bridge,
  ROUTES.swapAndBridge,
  ROUTES.dappBrowser,
  ROUTES.walletConnect,
  ROUTES.transactions
]

export const isSignAccountOpOverlayRoute = (pathname?: string | null): boolean =>
  SIGN_ACCOUNT_OP_OVERLAY_ROUTES.includes(pathname ?? '')
